import { Table } from 'react-bootstrap'
import ActionButtonProvider from '../../../../components/action_button/ActionButtonContext'
import OcOrdersRow from './OcOrdersRow'

const OcOrdersTable = ({
  data = [],
  onRowClick,
  statusUiMap,
  onSend,
  onIgnore,
  onReprocess,
  sendingIds
}) => {
  return (
    <Table hover responsive className="oc-fixed-table">
      <thead className="table-header-gray-poc">
        <tr>
          <th className="col-w-100">FECHA</th>
          <th className="col-w-100">OC RECIBIDA</th>
          <th className="col-w-250">SUCURSAL</th>
          <th className="col-w-100">% PROCESADO</th>
          <th className="col-w-100">PEDIDO</th>
          <th className="col-w-100">#ERP</th>
          <th className="col-w-180">USUARIO</th>
          <th className="col-w-130">DETALLES</th>
          <th className="col-w-120">ESTADO</th>
          <th className="col-w-70">ACCIÓN</th>
        </tr>
      </thead>

      <tbody>
        {!data || data.length === 0 ? (
          <tr>
            <td colSpan={10}>No hay resultados</td>
          </tr>
        ) : (
          <ActionButtonProvider>
            {data.map((model, index) => (
              <OcOrdersRow
                key={model.order_id ?? `${model.id}-error-${index}`}
                model={model}
                onClick={onRowClick}
                statusUiMap={statusUiMap}
                sendingIds={sendingIds}
                onSend={onSend}
                onReject={onIgnore}
                onReprocess={onReprocess}
              />
            ))}
          </ActionButtonProvider>
        )}
      </tbody>
    </Table>
  )
}

export default OcOrdersTable
